import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache, IntrospectionFragmentMatcher, defaultDataIdFromObject } from 'apollo-cache-inmemory'

import defaults from '@/graphql/local/default-value'
import resolvers from '@/graphql/local/resolvers'
import * as typeDefs from '@/graphql/local/type-defs.graphql'

import GraphqlService from '@/services/graphql'

import { VUE_APP_GRAPHQL_HTTP } from '@/helpers/env'
import GlobalErrorHandler from '@/helpers/global-error-handler'

import introspectionQueryResultData from '@/fragmentTypes.json'

Vue.use(VueApollo)

const AUTH_TOKEN = 'apollo-token'
const httpEndpoint = VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'

let instance = createProvider()

export default {
  instance
}

function createProvider() {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })

  const dataIdFromObject = object => {
    // Cache indicators by id and language
    const indicatorGraphTypes = ['GeneralIndicatorGraphType', 'ProjectIndicatorGraphType']
    if (indicatorGraphTypes.includes(object.__typename)) {
      if (!object.id) throw new Error("The field 'id' must be included in an indicator query.")
      if (!object.language) throw new Error("The field 'language' must be included in an indicator query.")
      if (object.language === 'DEFAULT') {
        // eslint-disable-next-line no-console
        console.warn('Received DEFAULT language for an indicator')
      }
      return `${object.__typename}:${object.id}:${object.language}`
    }
    // Default implementation
    return defaultDataIdFromObject(object)
  }
  const cache = new InMemoryCache({ fragmentMatcher, dataIdFromObject })

  const httpLink = createHttpLink({ uri: httpEndpoint, fetch: GraphqlService.graphQLFetcher })

  const apolloClient = new ApolloClient({
    link: ApolloLink.from([httpLink]),
    cache,
    resolvers,
    typeDefs,
    defaultOptions: {
      httpEndpoint,
      tokenName: AUTH_TOKEN,
      persisting: false,
      websocketsOnly: false,
      ssr: false
    }
  })

  cache.writeData({ data: defaults })

  let vueApollo = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'cache-and-network'
      }
    },
    errorHandler: (error, component, _, operationType) => {
      error.gqlOperationType = operationType
      GlobalErrorHandler(error, component)
    }
  })

  return vueApollo
}
